export default [
  {
    name: 'Account Overview',
    icon: 'ti-home',
    path: '/dashboard/overview'
  },
  {
    name: 'Transaction History',
    icon: 'ti-agenda',
    path: '/dashboard/transactions'
  },
  {
    name: 'Forms & Pamphlets',
    icon: 'ti-clipboard',
    path: '/dashboard/documents'
  },
  {
    name: 'Statements & Documents',
    icon: 'ti-archive',
    path: '/dashboard/statements'
  }
]



// WEBPACK FOOTER //
// ./src/sidebarLinks.js